import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const getPnlByYear = createAsyncThunk(
  "analytics/getPnlByYear",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { year } = formInfo;
      const res = await api.get(`user/pnlbyYear/${year}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getPnlByYearFiltered = createAsyncThunk(
  "analytics/getPnlByYearFiltered",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { year, filters } = formInfo;
      const res = await api.get(`user/pnlbyYear/${year}`, { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTickerPerformance = createAsyncThunk(
  "analytics/getTickerPerformance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/trades/ticker-performance");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTagPerformance = createAsyncThunk(
  "analytics/getTagPerformance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("tag/performance");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getEmotionalPerformance = createAsyncThunk(
  "analytics/getEmotionalPerformance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/reviews/emotional-performance");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getLeaderboard = createAsyncThunk(
  "analytics/getLeaderboard",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/leaderboard", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getLeaderboardPage = createAsyncThunk(
  "analytics/getLeaderboardPage",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/leaderboard/page", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

// TRADE-951 Insights endpoints

export const getSetupTypePerformance = createAsyncThunk(
  "analytics/getSetupTypePerformance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/reviews/setup-performance");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getPlanAdherence = createAsyncThunk(
  "analytics/getPlanAdherence",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/reviews/plan-adherence");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getReviewCoverage = createAsyncThunk(
  "analytics/getReviewCoverage",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/reviews/coverage");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getRiskRewardStats = createAsyncThunk(
  "analytics/getRiskRewardStats",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/stats/risk-reward");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getJournalFrequency = createAsyncThunk(
  "analytics/getJournalFrequency",
  async (formInfo = {}, { rejectWithValue }) => {
    try {
      const params = formInfo.period ? { period: formInfo.period } : {};
      const res = await api.get("journal/stats/frequency", { params });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getJournalStreak = createAsyncThunk(
  "analytics/getJournalStreak",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("journal/stats/streak");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getJournalCoverage = createAsyncThunk(
  "analytics/getJournalCoverage",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("journal/stats/coverage");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getAccountValueMetrics = createAsyncThunk(
  "analytics/getAccountValueMetrics",
  async (formInfo = {}, { rejectWithValue }) => {
    try {
      const params = formInfo.period ? { period: formInfo.period } : {};
      const res = await api.get("user/accountvalue/metrics", { params });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getOptionsExpiryPerformance = createAsyncThunk(
  "analytics/getOptionsExpiryPerformance",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/trades/options-expiry-performance");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTagCoOccurrence = createAsyncThunk(
  "analytics/getTagCoOccurrence",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("tag/co-occurrence");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTagPerformanceTimeseries = createAsyncThunk(
  "analytics/getTagPerformanceTimeseries",
  async (formInfo = {}, { rejectWithValue }) => {
    try {
      const { tag_id, period } = formInfo;
      const params = {};
      if (period) params.period = period;
      const res = await api.get(`tag/${tag_id}/timeseries`, { params });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
